export default __webpack_public_path__ + "static/media/horizontal-shadow.e7922789.png";